/*
 * Haye Nii product options (replaces the King Product Options app). No jQuery.
 * The fields themselves are drawn by snippets/product-options.liquid; this file only:
 *  1. shows/hides fields that depend on another option (data-show-if / data-show-values),
 *  2. stops Add to cart while a required field is empty (and says which one),
 *  3. never sends empty fields to the cart, shows a small preview of an uploaded photo,
 *  4. opens the picture guides (Size guide, ...) and the swipe view of picture tiles (Chain Style),
 *  5. opens every dropdown as the website's own list, not the phone's system list (the dropdown keeps the value).
 */
(function () {
  if (window.hayeniiOptionsLoaded) return;
  window.hayeniiOptionsLoaded = true;

  var MAX_UPLOAD_MB = 20;

  function controlOf(field) {
    // Picture tiles are radio buttons: use the chosen one (or the first one if none is chosen yet)
    return field.querySelector('input[type="radio"]:checked') || field.querySelector('select, input');
  }

  function propertyName(control) {
    return control.name.replace(/^properties\[/, '').replace(/\]$/, '');
  }

  // Current value of an option by its name: a Shopify variant option (the theme's dropdowns or buttons)
  // or one of our own fields. Searched inside the product area that holds the field.
  function currentValue(root, optionName) {
    var variantName = 'options[' + optionName + ']';
    var ownName = 'properties[' + optionName + ']';
    var elements = root.querySelectorAll('select, input');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (el.name !== variantName && el.name !== ownName) continue;
      if (el.type === 'radio' && !el.checked) continue;
      return el.value;
    }
    return null;
  }

  function areaOf(el) {
    return el.closest('product-info, .product, .shopify-section') || document;
  }

  function splitValues(text) {
    return (text || '').split('|').map(function (v) { return v.trim(); }).filter(Boolean);
  }

  // 1. Show/hide dependent fields. Hidden fields are disabled so they are never sent or required.
  function updateConditions(root) {
    root.querySelectorAll('[data-po-field][data-show-if]').forEach(function (field) {
      var value = currentValue(areaOf(field), field.dataset.showIf);
      var show = value !== null && splitValues(field.dataset.showValues).indexOf(value.trim()) !== -1;
      field.hidden = !show;
      field.querySelectorAll('select, input').forEach(function (control) {
        if (!control.closest('.po-tile--sold-out')) control.disabled = !show;
      });
      if (!show) clearError(field);
    });
  }

  function setError(field, message) {
    var error = field.querySelector('.po-field__error');
    var control = controlOf(field);
    if (error) error.textContent = message;
    field.classList.add('po-field--error');
    if (control) control.setAttribute('aria-invalid', 'true');
  }

  function clearError(field) {
    var error = field.querySelector('.po-field__error');
    var control = controlOf(field);
    if (error) error.textContent = '';
    field.classList.remove('po-field--error');
    if (control) control.removeAttribute('aria-invalid');
  }

  // Our fields that belong to this form (they sit outside it and point to it with form="...")
  function fieldsOfForm(form) {
    var fields = [];
    document.querySelectorAll('[data-po-field]').forEach(function (field) {
      var control = controlOf(field);
      if (control && control.form === form) fields.push(field);
    });
    return fields;
  }

  function problemOf(field) {
    var control = controlOf(field);
    if (!control || control.disabled || field.hidden) return null;
    var label = propertyName(control);
    if (control.type === 'file') {
      var file = control.files && control.files[0];
      if (file && file.size > MAX_UPLOAD_MB * 1024 * 1024) {
        return 'This photo is too large. Please choose one under ' + MAX_UPLOAD_MB + ' MB.';
      }
      if (control.hasAttribute('data-po-required') && !file) return 'Please choose a photo to upload.';
      return null;
    }
    if (control.hasAttribute('data-po-required') && control.value.trim() === '') {
      return control.tagName === 'SELECT' ? 'Please choose a ' + label + '.' : 'Please fill in "' + label + '".';
    }
    return null;
  }

  // 2 + 3. Runs before the theme's product-form.js (capture phase), for the button and the Enter key alike.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.elements) return;
    var fields = fieldsOfForm(form);

    if (fields.length) {
      updateConditions(areaOf(fields[0]));
      var firstProblem = null;
      fields.forEach(function (field) {
        var message = problemOf(field);
        if (message) {
          setError(field, message);
          if (!firstProblem) firstProblem = field;
        } else {
          clearError(field);
        }
      });

      if (firstProblem) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var control = controlOf(firstProblem);
        firstProblem.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // A dropdown is opened through the button on top of it: put the keyboard there
        var box = control && control.tagName === 'SELECT' && control.closest('.hn-dd');
        var boxButton = box && box.querySelector('.hn-dd__hit');
        if (boxButton) boxButton.focus({ preventScroll: true });
        else if (control) control.focus({ preventScroll: true });
        return;
      }
    }

    // Don't send empty boxes to the cart (King never did), e.g. an unused "Custom Language" or "Ring Size":
    // switch every empty properties[...] box of this form off just while the form is read, then back on.
    var emptied = [];
    Array.prototype.forEach.call(form.elements, function (control) {
      if (!control.name || control.name.indexOf('properties[') !== 0 || control.disabled) return;
      if (control.type === 'checkbox' || control.type === 'radio') return;
      var empty = control.type === 'file' ? !(control.files && control.files.length) : control.value.trim() === '';
      if (empty) {
        control.disabled = true;
        emptied.push(control);
      }
    });
    if (emptied.length) {
      setTimeout(function () {
        emptied.forEach(function (control) { control.disabled = false; });
      }, 0);
    }
  }, true);

  // Re-check dependent fields when any option changes; clear a field's message once it is fixed.
  function onChange(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var field = target.closest('[data-po-field]');
    if (field && !problemOf(field)) clearError(field);
    if (field && target.tagName === 'SELECT') updatePicker(field);
    if (target.name && (target.name.indexOf('options[') === 0 || target.name.indexOf('properties[') === 0)) {
      updateConditions(areaOf(target));
    }
    // Photo preview
    if (field && target.type === 'file') {
      var preview = field.querySelector('.po-field__preview');
      var file = target.files && target.files[0];
      if (preview) {
        if (preview.src) URL.revokeObjectURL(preview.src);
        if (file && file.type.indexOf('image/') === 0) {
          preview.src = URL.createObjectURL(file);
          preview.alt = file.name;
          preview.hidden = false;
        } else {
          preview.removeAttribute('src');
          preview.hidden = true;
        }
      }
    }
  }
  document.addEventListener('change', onChange);
  document.addEventListener('input', onChange);

  // Swipe picture box: which picture is in view, counter "2 of 5", and the chosen one shown as "Selected"
  function slideIndex(slides) {
    var width = slides.clientWidth || 1;
    var first = slides.children[0];
    var step = first ? first.offsetWidth + parseFloat(getComputedStyle(slides).columnGap || 0) : width;
    return Math.max(0, Math.min(slides.children.length - 1, Math.round(slides.scrollLeft / (step || width))));
  }

  function updateCount(slides) {
    var count = slides.parentNode.querySelector('[data-po-count]');
    if (count) count.textContent = (slideIndex(slides) + 1) + ' of ' + slides.children.length;
  }

  function markSelected(dialog, value) {
    dialog.querySelectorAll('[data-po-choose]').forEach(function (button) {
      var name = button.getAttribute('data-po-choose');
      var selected = name === value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.textContent = selected ? '✓ Selected' : 'Choose';
    });
  }

  // The box that opens the picture box shows the chosen name and a small photo
  function updatePicker(field) {
    var picker = field.querySelector('.po-picker');
    var select = field.querySelector('select');
    if (!picker || !select) return;
    var value = select.value;
    picker.querySelector('.po-picker__value').textContent = value || 'Please choose';
    var thumb = picker.querySelector('.po-picker__thumb');
    var source = field.querySelector('[data-po-choose="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]');
    var src = source ? source.getAttribute('data-po-src') : '';
    if (src) {
      thumb.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120'; // small copy of the photo
      thumb.hidden = false;
    } else {
      thumb.hidden = true;
    }
  }

  document.addEventListener(
    'scroll',
    function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-po-slides]')) updateCount(event.target);
    },
    true
  );

  // Smooth open/close (Apple-like sheet). Closing plays a short animation first, then really closes.
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function openGuide(dialog) {
    dialog.classList.remove('is-closing');
    dialog.showModal();
    document.documentElement.classList.add('po-guide-open');
  }

  function closeGuide(dialog) {
    if (!dialog.open || dialog.classList.contains('is-closing')) return;
    var finish = function () {
      dialog.classList.remove('is-closing');
      dialog.close();
      document.documentElement.classList.remove('po-guide-open');
    };
    if (reduceMotion) return finish();
    dialog.classList.add('is-closing');
    setTimeout(finish, 230);
  }

  // A little nudge so shoppers see they can swipe: the pictures glide ~1/4 to the side (showing more of the
  // next one) and settle back. Done by scrolling (not moving the box), so no empty space ever shows.
  function peek(slides) {
    if (reduceMotion || slides.children.length < 2) return;
    var start = slides.scrollLeft;
    var atEnd = slideIndex(slides) === slides.children.length - 1;
    var distance = Math.round(slides.clientWidth * 0.28) * (atEnd ? -1 : 1);
    var duration = 1100;
    var began = null;
    var stopped = false;
    var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    slides.style.scrollSnapType = 'none'; // let it glide freely during the nudge
    function step(now) {
      if (stopped) return;
      if (began === null) began = now;
      var t = Math.min(1, (now - began) / duration);
      // out and back: 0 -> 1 -> 0
      var amount = t < 0.45 ? ease(t / 0.45) : 1 - ease((t - 0.45) / 0.55);
      slides.scrollLeft = start + distance * amount;
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        slides.scrollLeft = start;
        slides.style.scrollSnapType = '';
      }
    }
    requestAnimationFrame(step);
    // If the shopper touches it during the nudge, stop and let them swipe
    slides.addEventListener('pointerdown', function () {
      stopped = true;
      slides.style.scrollSnapType = '';
    }, { once: true });
  }

  // Esc key: close with the animation too
  document.addEventListener(
    'cancel',
    function (event) {
      if (event.target && event.target.classList && event.target.classList.contains('po-guide')) {
        event.preventDefault();
        closeGuide(event.target);
      }
    },
    true
  );

  // 4. Picture guides (native <dialog>: Esc closes it, focus returns to the link)
  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-po-guide]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-po-guide'));
      if (dialog && dialog.showModal) {
        // Load the guide pictures now (lazy pictures in a closed popup can stay blank on iPhones)
        dialog.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        openGuide(dialog);
        // Swipe view: start at the tapped picture, or at the choice that is selected now
        var slides = dialog.querySelector('[data-po-slides]');
        if (slides) {
          var index = 0;
          if (opener.hasAttribute('data-po-slide')) {
            index = Number(opener.getAttribute('data-po-slide'));
          } else {
            var ownField = opener.closest('[data-po-field]');
            var current = ownField ? controlOf(ownField) : null;
            Array.prototype.forEach.call(slides.children, function (slide, i) {
              var button = slide.querySelector('[data-po-choose]');
              if (current && button && button.getAttribute('data-po-choose') === current.value) index = i;
            });
          }
          var slide = slides.children[index];
          slides.scrollLeft = slide ? slide.offsetLeft - slides.offsetLeft : 0;
          var pickedField = opener.closest('[data-po-field]');
          var picked = pickedField ? controlOf(pickedField) : null;
          markSelected(dialog, picked ? picked.value : '');
          updateCount(slides);
          setTimeout(function () { peek(slides); }, 500);
        }
      }
      return;
    }
    // Arrows in the swipe view (for computers)
    var arrow = event.target.closest && event.target.closest('[data-po-step]');
    if (arrow) {
      var strip = arrow.closest('dialog').querySelector('[data-po-slides]');
      var next = strip.children[slideIndex(strip) + Number(arrow.getAttribute('data-po-step'))];
      if (next) strip.scrollTo({ left: next.offsetLeft - strip.offsetLeft, behavior: 'smooth' });
      return;
    }
    // "Choose ..." in the swipe view: tick that tile and close
    var chooser = event.target.closest && event.target.closest('[data-po-choose]');
    if (chooser) {
      var field = chooser.closest('[data-po-field]');
      var value = chooser.getAttribute('data-po-choose');
      var select = field ? field.querySelector('select') : null;
      if (select) {
        // Dropdown: pick that choice
        for (var j = 0; j < select.options.length; j++) {
          if (select.options[j].value === value && !select.options[j].disabled) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            updatePicker(field);
          }
        }
      } else {
        // Picture tiles: tick that tile
        var radios = field ? field.querySelectorAll('input[type="radio"]') : [];
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === value && !radios[i].disabled) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
      closeGuide(chooser.closest('dialog'));
      return;
    }
    if (event.target.closest && event.target.closest('[data-po-guide-close]')) {
      closeGuide(event.target.closest('dialog'));
      return;
    }
    // Click on the dark area around the guide closes it
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('po-guide')) closeGuide(event.target);
  });

  // 5. Length: a gentle note when a kids' length (30 cm / 12 inch) is chosen, on any product
  var KIDS_LENGTH = /^\s*30\s*cm/i;

  function lengthNotes(root) {
    root.querySelectorAll('select[name="options[Length]"], select[name="properties[Length]"]').forEach(function (select) {
      var holder = select.closest('.product-form__input, .po-field') || select.parentNode;
      var note = holder.querySelector('.po-length-note');
      var isKids = KIDS_LENGTH.test(select.value);
      if (isKids && !note) {
        note = document.createElement('p');
        note.className = 'po-length-note';
        note.setAttribute('role', 'status');
        note.textContent = "30 cm is a kids' size. For adults we recommend 35–40 cm.";
        var wrap = select.closest('.select, .po-field__select-wrap') || select;
        wrap.insertAdjacentElement('afterend', note);
      } else if (!isKids && note) {
        note.remove();
      }
    });
  }

  // 7. Every dropdown (ours and the theme's Color/Length) opens the website's own list instead of the phone's
  // system list (dark and off-brand on Firefox Android and iPhone). The box looks exactly as before and the real
  // dropdown is still what goes into the cart: an invisible button lies on top of it and opens our list below.
  var openList = null;
  var pendingFocus = null;

  function dropLists(root) {
    root.querySelectorAll('select.select__select[name^="options["], select.po-field__select').forEach(function (select) {
      var wrap = select.closest('.select, .po-field__select-wrap');
      if (!wrap || wrap.hidden) return;
      var hit = wrap.querySelector('.hn-dd__hit');
      if (!hit) {
        hit = document.createElement('button');
        hit.type = 'button';
        hit.className = 'hn-dd__hit';
        hit.setAttribute('aria-haspopup', 'listbox');
        hit.setAttribute('aria-expanded', 'false');
        // so screen readers also read the help text and "Please choose ..." message
        if (select.getAttribute('aria-describedby')) hit.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));
        wrap.appendChild(hit);
        wrap.classList.add('hn-dd');
        select.tabIndex = -1;
        select.setAttribute('aria-hidden', 'true');
      }
      var label = select.id && document.querySelector('label[for="' + select.id + '"]');
      var name = label ? label.textContent.replace('*', '').trim() : '';
      var chosen = select.selectedIndex >= 0 ? select.options[select.selectedIndex].text.trim() : '';
      hit.setAttribute('aria-label', (name ? name + ': ' : '') + (chosen || 'Please choose'));
      hit.dataset.name = name;
      hit.disabled = select.disabled;
    });
    if (openList && !openList.list.isConnected) {
      openList = null;
      document.documentElement.classList.remove('hn-dd-open');
    }
    // The theme redrew its choices after a pick and focus fell back to the page: put it back on the same box
    if (pendingFocus && (!document.activeElement || document.activeElement === document.body)) {
      var again = Array.prototype.filter.call(document.querySelectorAll('.hn-dd select'), function (s) {
        return s.name === pendingFocus;
      })[0];
      var hitAgain = again && again.closest('.hn-dd').querySelector('.hn-dd__hit');
      if (hitAgain) {
        hitAgain.focus({ preventScroll: true });
        pendingFocus = null;
      }
    }
  }

  function openDrop(wrap) {
    closeDrop(false);
    var select = wrap.querySelector('select');
    var hit = wrap.querySelector('.hn-dd__hit');
    if (!select || !hit || hit.disabled) return;
    var list = document.createElement('ul');
    list.className = 'hn-dd__list';
    list.id = (select.id || 'hn-dd') + '-list';
    list.setAttribute('role', 'listbox');
    if (hit.dataset.name) list.setAttribute('aria-label', hit.dataset.name);
    Array.prototype.forEach.call(select.options, function (o) {
      if (o.value === '') return;
      var item = document.createElement('li');
      item.className = 'hn-dd__option';
      item.setAttribute('role', 'option');
      item.tabIndex = -1;
      item.dataset.value = o.value;
      var main = document.createElement('span');
      main.textContent = o.value;
      item.appendChild(main);
      // "45cm - Sold out" / "Gold - Unavailable": show the name, and the reason small and grey
      var text = o.text.replace(/\s+/g, ' ').trim();
      var plain = o.value.replace(/\s+/g, ' ').trim();
      var note = text.indexOf(plain) === 0 ? text.slice(plain.length).replace(/^\s*[-–]\s*/, '') : '';
      if (o.disabled && !note) note = 'Sold out';
      if (note) {
        var small = document.createElement('span');
        small.className = 'hn-dd__note';
        small.textContent = note;
        item.appendChild(small);
        item.classList.add('is-unavailable');
      }
      if (o.disabled) item.setAttribute('aria-disabled', 'true');
      item.setAttribute('aria-selected', o.value === select.value ? 'true' : 'false');
      list.appendChild(item);
    });
    wrap.appendChild(list);
    hit.setAttribute('aria-expanded', 'true');
    hit.setAttribute('aria-controls', list.id);
    openList = { wrap: wrap, list: list, hit: hit, select: select };
    // task 38: the phone "Add to cart" card steps aside while a list is open (assets/sticky-add-to-cart.js)
    document.documentElement.classList.add('hn-dd-open');
    var current = list.querySelector('[aria-selected="true"]') || list.querySelector('.hn-dd__option:not([aria-disabled])');
    if (current) {
      list.scrollTop = Math.max(0, current.offsetTop - list.clientHeight / 2);
      current.focus({ preventScroll: true });
    }
    // keep the whole list on the screen, and above the chat bubble + phone "Add to cart" bar at the bottom
    // (they would cover the last choice); a smaller gap on very short screens (phone turned sideways)
    var overflow = list.getBoundingClientRect().bottom - (window.innerHeight - bottomKeepOut(list));
    if (overflow > 0) window.scrollBy({ top: overflow, behavior: 'smooth' });
  }

  // Space to keep free at the bottom of the screen: normally ~96 px (chat bubble), more when the phone
  // "Add to cart" bar is showing, because then the chat bubble is lifted above the bar
  function bottomKeepOut(list) {
    var h = window.innerHeight;
    var keep = Math.min(96, h * 0.12);
    var listBox = list.getBoundingClientRect();
    // the "Add to cart" card hides while a list is open (task 38), so only a card that stays counts
    var root = document.documentElement;
    var bar = root.classList.contains('hn-sticky-atc-on') && !root.classList.contains('hn-dd-open') && document.querySelector('.hn-sticky-atc');
    if (bar) {
      var barTop = bar.getBoundingClientRect().top;
      if (barTop > 0 && barTop < h) keep = Math.max(keep, h - barTop + 8);
    }
    var host = document.getElementById('smart-bot-container');
    var icon = host && host.shadowRoot && host.shadowRoot.querySelector('[class*="chat-icon-container"]');
    if (icon) {
      var r = icon.getBoundingClientRect();
      // only when the bubble is beside the list (it sits bottom-right)
      if (r.height && r.top > h / 2 && r.left < listBox.right && r.right > listBox.left) {
        // the bubble may still be moving up above the bar: use where it ends up (bar top - 12 px - its height)
        var top = bar ? Math.min(r.top, bar.getBoundingClientRect().top - 12 - r.height) : r.top;
        keep = Math.max(keep, h - top + 8);
      }
    }
    return Math.min(keep, h * 0.4);
  }

  function closeDrop(focusBox) {
    if (!openList) return;
    var o = openList;
    openList = null;
    document.documentElement.classList.remove('hn-dd-open');
    o.list.remove();
    o.hit.setAttribute('aria-expanded', 'false');
    o.hit.removeAttribute('aria-controls');
    if (focusBox && o.hit.isConnected) o.hit.focus({ preventScroll: true });
  }

  function choose(item) {
    if (!openList || item.getAttribute('aria-disabled') === 'true') return;
    var select = openList.select;
    closeDrop(true);
    if (select.value !== item.dataset.value) {
      pendingFocus = select.name;
      setTimeout(function () { pendingFocus = null; }, 4000);
      select.value = item.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true })); // same as choosing it in the dropdown
    }
    dropLists(document);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var hit = target.closest('.hn-dd__hit');
    if (hit) {
      if (openList && openList.hit === hit) closeDrop(false);
      else openDrop(hit.parentNode);
      return;
    }
    var item = target.closest('.hn-dd__option');
    if (item) {
      choose(item);
      return;
    }
    // Tapping the field's name opens the phone's own list on some phones: put the focus on our box instead
    var label = target.closest('label[for]');
    var labelled = label && document.getElementById(label.htmlFor);
    if (labelled && labelled.tagName === 'SELECT' && labelled.closest('.hn-dd')) {
      event.preventDefault();
      labelled.closest('.hn-dd').querySelector('.hn-dd__hit').focus();
    }
    if (openList && !target.closest('.hn-dd__list')) closeDrop(false);
  });

  // iPhone Safari sends no "click" for a tap on plain page areas, so close an open list as soon as the finger
  // (or mouse) touches anything outside it
  document.addEventListener('pointerdown', function (event) {
    var target = event.target;
    if (!openList || !target.closest) return;
    if (target.closest('.hn-dd__list') || target.closest('.hn-dd__hit') === openList.hit) return;
    closeDrop(false);
  });
  // Leaving the page (or Back/Forward cache): never come back to a list left open
  window.addEventListener('pagehide', function () { closeDrop(false); });

  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (!target.classList) return;
    if (target.classList.contains('hn-dd__hit')) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        openDrop(target.parentNode);
      } else if (event.key === 'Escape' && openList) {
        closeDrop(true);
      }
      return;
    }
    if (!openList || !target.classList.contains('hn-dd__option')) return;
    var items = Array.prototype.slice.call(openList.list.querySelectorAll('.hn-dd__option'));
    var index = items.indexOf(target);
    var next = null;
    if (event.key === 'ArrowDown') next = items[Math.min(items.length - 1, index + 1)];
    else if (event.key === 'ArrowUp') next = items[Math.max(0, index - 1)];
    else if (event.key === 'Home') next = items[0];
    else if (event.key === 'End') next = items[items.length - 1];
    if (next) {
      event.preventDefault();
      next.focus();
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      choose(target);
    } else if (event.key === 'Escape') {
      event.preventDefault();
      closeDrop(true);
    } else if (event.key === 'Tab') {
      closeDrop(true); // the Tab then moves on from the box as usual
    }
  });

  // The theme redraws its own dropdowns when the shopper changes Plating etc.: check again after that
  var lengthTimer;
  new MutationObserver(function () {
    clearTimeout(lengthTimer);
    lengthTimer = setTimeout(function () { dropLists(document); lengthNotes(document); }, 50);
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', function () { dropLists(document); lengthNotes(document); });

  // 6. Start on an adult length (owner: 35 cm) when a product's own Shopify "Length" choice opens on the kids'
  // 30 cm. Only when the page was opened without a chosen variant (a link from an ad that picked a length is kept).
  function startOnAdultLength(tries) {
    if (/[?&]variant=/.test(window.location.search)) return;
    var select = document.querySelector('select[name="options[Length]"]');
    if (!select || !KIDS_LENGTH.test(select.value)) return;
    // The theme's Add to cart box must be fully ready, or changing the length throws a script error.
    // Check the real box on the page (not only that its code was loaded); try again for up to ~5 seconds.
    var section = select.closest('product-info');
    var cartBox = section ? section.querySelector('product-form') : null;
    if (!cartBox || typeof cartBox.toggleSubmitButton !== 'function') {
      tries = tries || 0;
      if (tries < 50) setTimeout(function () { startOnAdultLength(tries + 1); }, 100);
      return;
    }
    var idInput = document.querySelector('form[id^="product-form-"] input[name="id"]');
    var startId = idInput ? idInput.value : null;
    var startValue = select.value;
    for (var i = 0; i < select.options.length; i++) {
      var option = select.options[i];
      if (/^\s*35\s*cm/i.test(option.value) && !option.disabled) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true })); // the theme updates price, photo and cart choice
        // Safety: the cart choice must really have changed. If not, put the dropdown back to what the cart has.
        setTimeout(function () {
          var input = document.querySelector('form[id^="product-form-"] input[name="id"]');
          var current = document.querySelector('select[name="options[Length]"]');
          if (input && startId && input.value === startId && current && current.value !== startValue) {
            current.value = startValue;
            dropLists(document);
            lengthNotes(document);
          }
        }, 2500);
        return;
      }
    }
  }

  // After the browser's Back button, the hidden dropdown keeps the shopper's real choice while the box would show
  // the default: always redraw every picture box from the hidden dropdown (it is what goes into the cart).
  function syncPickers() {
    document.querySelectorAll('[data-po-field]').forEach(function (field) {
      if (field.querySelector('.po-picker')) updatePicker(field);
    });
  }
  window.addEventListener('pageshow', function () { syncPickers(); dropLists(document); });

  function init() {
    syncPickers();
    dropLists(document);
    // Wait until the theme's dropdowns, product section and Add to cart form are ready to react (product-form.js
    // loads after this file), so the cart choice changes with the dropdown without a script error
    if (window.customElements && customElements.whenDefined && window.Promise) {
      Promise.all(['variant-selects', 'product-info', 'product-form'].map(function (name) {
        return customElements.whenDefined(name);
      })).then(function () { setTimeout(startOnAdultLength, 0); });
    }
    lengthNotes(document);
    updateConditions(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor: section reloaded, or the theme redrew the variant picker
  document.addEventListener('shopify:section:load', init);
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { setTimeout(init, 0); });
  }
})();
